<template>
  <v-form>
    <v-container>
      <v-layout wrap>
        <div class="decretosBoton">
          <v-menu bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small tile outline color="primary">
                <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
              </v-btn>
            </template>
            <v-card class="px-2 py-1">
              <v-card-text class="black--text body-2">
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>
                  <b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas</b>'...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días...'
                </span>
                <br />
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>Registrar deudas u obligaciones con entidades estatales recaudadoras, por ejemplo, Servicio de Impuestos Nacionales, Aduana Nacional de Bolivia, Municipios y otros, por concepto de impuestos, gravámenes y tasas exigibles.</span>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-flex xs12 sm12 md12 class="decretos">
          <alert-extendible texto='<b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas</b>"...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días..."'></alert-extendible>
        </v-flex>
        <v-flex xs12 sm12 md12 class="decretos">
          <alert-extendible texto="Registrar deudas u obligaciones con entidades estatales recaudadoras, por ejemplo, Servicio de Impuestos Nacionales, Aduana Nacional de Bolivia, Municipios y otros, por concepto de impuestos, gravámenes y tasas exigibles."></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-end>
        <v-flex xs12 sm12 md12 class="text-xs-right">
          <v-btn color="success" dark @click.stop="dialog = true">
            <v-icon>add</v-icon>&nbsp;Adicionar
          </v-btn>
        </v-flex>
      </v-layout>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-dialog v-model="dialog" scrollable :max-width="deleteMode?600:1200" persistent>
          <v-card>
            <v-toolbar dark color="primary" right>
              <v-toolbar-title>
                <h4>Deudas al Fisco</h4>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <div class="decretosBoton">
                    <v-menu bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small tile outline color="primary">
                          <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                        </v-btn>
                      </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>Registrar deudas u obligaciones con entidades estatales recaudadoras, por ejemplo, Servicio de Impuestos Nacionales, Aduana Nacional de Bolivia, Municipios y otros, por concepto de impuestos, gravámenes y tasas exigibles.</span>
                          <br />
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>
                            <b>Tipo de Adquisición:</b> Se deberá seleccionar “Propio” en el marco del artículo 13 de la Ley 2492.
                            <br />
                            <b>Referencia del Acreedor:</b> Se debe detallar al acreedor (El nombre de la Entidad estatal recaudadora del impuesto, gravamen y tasa exigibles, como ser: SIN, Aduana, Alcaldía, etc.) y el tipo de garantía (hipotecaria, prendaria, personal u otra).
                            <br />
                            <b>Ubicación:</b> Señalará el país, departamento y localidad donde se localiza la Entidad estatal recaudadora.
                            <br />
                            <b>Saldo en Bs.:</b> Declarar en moneda nacional (Bs) sin decimales, el dato real o estimación más próxima de la deuda.
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </div>
                  <v-flex sm12 md12 class="decretos">
                    <alert-extendible v-show="!deleteMode" texto="Registrar deudas u obligaciones con entidades estatales recaudadoras, por ejemplo, Servicio de Impuestos Nacionales, Aduana Nacional de Bolivia, Municipios y otros, por concepto de impuestos, gravámenes y tasas exigibles."></alert-extendible>
                  </v-flex>
                  <v-flex sm12 md12 class="decretos">
                    <alert-extendible v-show="!deleteMode" texto="<b>Tipo de Adquisición:</b> Se deberá seleccionar “Propio” en el marco del artículo 13 de la Ley 2492.<br />
                      <b>Referencia del Acreedor:</b> Se debe detallar al acreedor (El nombre de la Entidad estatal recaudadora del impuesto, gravamen y tasa exigibles, como ser: SIN, Aduana, Alcaldía, etc.) y el tipo de garantía (hipotecaria, prendaria, personal u otra).<br />
                      <b>Ubicación:</b> Señalará el país, departamento y localidad donde se localiza la Entidad estatal recaudadora.<br />
                      <b>Saldo en Bs.:</b> Declarar en moneda nacional (Bs) sin decimales, el dato real o estimación más próxima de la deuda."></alert-extendible>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-alert
                      :value="true"
                      type="warning"
                      v-show="deleteMode"
                      outline
                    >¿Está seguro de eliminar el registro de deudas al fisco siguiente?</v-alert>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="ubicacion"
                          :rules="textRules"
                          v-on="on"
                          label="Ubicación (Ciudad y País)*"
                          :disabled="deleteMode"
                          maxlength="100"
                        ></v-text-field>
                      </template>
                      <span>Ubicación: Señalará el país, departamento y localidad donde se localiza la Entidad estatal recaudadora.</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md6>
                    <v-currency-field
                      v-model="saldo"
                      label="Saldo en Bs.*"
                      :rules="numbersRules"
                      v-bind="currency_config"
                      :disabled="this.deleteMode"
                      required
                    ></v-currency-field>
                  </v-flex>
                  <v-flex sm12 md6>
                    <v-select
                      :no-data-text="$t('comun.sin_datos')"
                      v-model="codTipoAdquisicion"
                      :items="itemsTipoAdquisicion"
                      item-text="tipadq_descripcion"
                      item-value="tipadq_codigo"
                      label="Tipo de Adquisición*"
                      :rules="dRules"
                      required
                      :disabled="this.deleteMode"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="referenciaAcreedor"
                          :rules="textRules"
                          v-on="on"
                          label="Referencia del Acreedor*"
                          :disabled="deleteMode"
                          maxlength="100"
                        ></v-text-field>
                      </template>
                      <span>Referencia del Acreedor: Se debe detallar al acreedor (El nombre de la Entidad estatal recaudadora del impuesto, gravamen y tasa exigibles, como ser: SIN, Aduana, Alcaldía, etc.) y el tipo de garantía (hipotecaria, prendaria, personal u otra).</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-textarea
                          @change="observacion = $util.sanitiza(observacion)"
                          v-model="observacion"
                          label="Observaciones"
                          maxlength="250"
                          :counter="250"
                          hint='Máximo 250 caracteres.'
                          persistent-hint
                          :rules="$validate(['text_area'])"
                          v-on="on"
                          :disabled="deleteMode"
                          rows="1"
                          auto-grow
                        ></v-textarea>
                      </template>
                      <span>Se consignará cualquier aclaración que el declarante considere pertinente, respecto a los datos de “Deudas al Fisco”.</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <br />
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-subheader>
                      <p class="plomo--text">Por favor llene los campos requeridos*</p>
                    </v-subheader>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loadingButton" @click="guardar()">
                  <div v-if="deleteMode === true"><v-icon>delete</v-icon>&nbsp;Eliminar</div>
                  <div v-else><v-icon>save</v-icon>&nbsp;Guardar</div>
                </v-btn>
                <v-btn color="error" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-form>
      <v-layout wrap>
        <v-flex sm12 md12>
          <v-alert :value="true" :type="statusError" v-show="codError !== null">{{this.msgError}}</v-alert>
        </v-flex>
        <v-flex sm12 md12 v-if="this.nro>0">
          <v-data-table
            :headers="headers"
            :items="datos"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="no-data">
              <v-alert
                class="tamanioBoton"
                :value="true"
                color="info"
                outline
                icon="info"
              >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
            </template>
            <template slot="items" slot-scope="props" class="justify-center layout px-0">
              <td>{{ props.item.nro }}</td>
              <td>
                <v-tooltip top color="blue">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="editItem(props.item)" v-on="on">
                      <v-icon color="blue">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top color="red">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="deleteItem(props.item)" v-on="on">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.deu_ubicacion }}</td>
              <td>{{ formatPrice(props.item.deu_saldo) }}</td>
              <td>{{ props.item.tipadq_descripcion }}</td>
              <td>{{ props.item.deu_referencia_acreedor }}</td>
              <td><text-extendible :texto='props.item.deu_observacion'></text-extendible></td>
            </template>
            <template
              v-slot:pageText="props"
            >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
          </v-data-table>
        </v-flex>
        <v-flex sm12 md12 v-else>
          <v-alert
            class="tamanioBoton"
            :value="true"
            color="info"
            icon="info"
          >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
export default {
  mixins: [Parametricas, validate],
  created () {
    if (this.$storage.get('ex') === 1 && this.itemsTipoAdquisicion.length === 0) {
      this.obtenerDeudasAnteriores();
      this.obtenerTipoAdquisicionParametrica().then(respuesta => {
        this.itemsTipoAdquisicion = respuesta.datos;
      });
    }
  },
  data: () => ({
    loadingButton: false,
    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Acciones', sortable: false, value: 'acciones' },
      { text: 'Ubicación', sortable: false, value: 'deu_ubicacion' },
      { text: 'Saldo en Bs.', sortable: false, value: 'deu_saldo' },
      {
        text: 'Tipo de Adquisición',
        sortable: false,
        value: 'tipadq_descripcion'
      },
      {
        text: 'Referencia del Acreedor',
        sortable: false,
        value: 'deu_referencia_acreedor'
      },
      { text: 'Observaciones', sortable: false, value: 'deu_observacion' }
    ],
    datos: [],
    codPersona: 1,
    codDeclaracion: '1_1',
    tipoDeuda: 1,
    rowsPerPageItems: [5, 10, 25, {'text': 'Todo', 'value': -1}],
    codTipoAdquisicion: null,
    itemsTipoAdquisicion: [],
    referenciaAcreedor: '',
    ubicacion: '',
    saldo: 0,
    observacion: '',
    codDeuda: 0,
    entidad: null,
    cargo: null,
    nro: 0,
    dialog: false,
    editMode: false,
    deleteMode: false,
    codError: null,
    msgError: null,
    statusError: null,
    dRules: [v => !!v || 'Este campo es requerido'],
    textRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-_/.*()"“”,.;:=#°ºñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜÇç$ \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    numbersRules: [v => !!v || 'Este campo es requerido y debe ser un monto en Bolivianos',
      v => v.length < 11 || 'El valor solo puede tener máximo 8 números'],
    currency_config: {
      thousands: '.',
      decimal: ',',
      prefix: 'Bs.',
      precision: 0,
      masked: false,
      allowBlank: true
    },
    valid: true
  }),
  methods: {
    obtenerDeudasAnteriores () {
      this.$service.get(`djbr_registro/deudas/4`, {}).then(response => {
        this.nro = 0;
        if (response.length >= 1 && response[0].deu_codigo !== -1) {
          this.datos = response;
          for (let i = 0; i < this.datos.length; i++) {
            this.datos[i].nro = ++this.nro;
          }
        } else {
          this.datos = [];
        }
      });
    },
    cancel () {
      this.dialog = false;
      this.editMode = false;
      this.deleteMode = false;
      this.reinicializa();
      this.loadingButton = false;
    },
    guardar () {
      if (this.deleteMode) {
        this.delete();
      } else {
        if (this.$refs.form.validate()) {
          this.loadingButton = true;
          if (this.saldo < 1) {
            this.$message['warning']('Por Favor revise el saldo de la deuda no es válido.');
            this.loadingButton = false;
          } else {
            if (this.editMode) {
              this.update();
            } else {
              this.save();
            }
          }
        } else {
          this.$message['warning']('Por Favor revise los datos requeridos..');
        }
      }
    },
    save () {
      let params = {
        cod_tipo_adquisicion: this.codTipoAdquisicion,
        referencia_acreedor: this.referenciaAcreedor,
        ubicacion: this.ubicacion,
        saldo: this.saldo,
        observacion: this.observacion
      };
      this.$service
        .post(`djbr_registro/deudas_fisco`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.editMode = false;
              this.dialog = false;
              this.reinicializa();
              this.obtenerDeudasAnteriores();
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    editItem (item) {
      this.cargaData(item);
      this.editMode = true;
      this.dialog = true;
    },
    update () {
      let params = {
        cod_deuda: this.codDeuda,
        cod_tipo_adquisicion: this.codTipoAdquisicion,
        referencia_acreedor: this.referenciaAcreedor,
        ubicacion: this.ubicacion,
        saldo: this.saldo,
        observacion: this.observacion
      };
      this.$service
        .put(`djbr_registro/deudas_fisco`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerDeudasAnteriores();
              this.editMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    reinicializa () {
      this.ubicacion = null;
      this.saldo = 0;
      this.codTipoAdquisicion = null;
      this.referenciaAcreedor = null;
      this.observacion = null;
      this.codDeuda = null;
      this.$refs.form.resetValidation();
    },
    delete () {
      this.$service
        .delete('djbr_registro/deudas/' + this.codDeuda)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerDeudasAnteriores();
              this.deleteMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    deleteItem (item) {
      this.cargaData(item);
      this.deleteMode = true;
      this.dialog = true;
      this.$refs.form.resetValidation();
    },
    cargaData (item) {
      this.ubicacion = item.deu_ubicacion;
      this.saldo = item.deu_saldo.replace('.00', '');
      this.codTipoAdquisicion = item.tipadq_codigo;
      this.referenciaAcreedor = item.deu_referencia_acreedor;
      this.observacion = item.deu_observacion;
      this.codDeuda = item.deu_codigo;
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace(',', '.').replace('.00', '');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/deudas/fisco.vue